import useDispatchify from 'common/hooks/utils/useDispatchify';
import { deleteSensorAuthorization } from 'common/services/sensors.service';
import useToast from 'components/hooks/useToast';
import { useSelector } from 'react-redux';
import { getSensorAuthorizations as getSensorAuthorizationsCaller } from 'state/callers';
import { getSensorAuthorizationByIdSelector } from 'state/selectors/sensors-authorizations';

const useDeleteIntegration = integrationId => {
  const integration = useSelector(
    getSensorAuthorizationByIdSelector(integrationId)
  );
  const integrationName = integration?.name || 'Integration';
  const getSensorAuthorizations = useDispatchify(getSensorAuthorizationsCaller);
  const toast = useToast();

  const successMessage = message =>
    toast({ autoHideDuration: 3000, message, variant: 'success' });

  const deleteIntegration = async ({ isSoftDelete = false } = {}) => {
    if (!integration?.id) return;
    await deleteSensorAuthorization(integrationId, {
      ...(isSoftDelete && { is_soft_delete: true })
    });
    getSensorAuthorizations();

    if (isSoftDelete) {
      toast({
        autoHideDuration: 3000,
        message: `${integrationName} was successfully deleted.`
      });
    } else {
      successMessage(
        `${integrationName} is currently being deleted. it might take sometime to complete.`
      );
    }
  };

  return { deleteIntegration };
};

export default useDeleteIntegration;
